export interface CopySourceButton {
  textContent: string | null;
  disabled: boolean;
  setAttribute(name: string, value: string): void;
}

export async function copySourceWithFeedback(
  button: CopySourceButton,
  source: string,
  writeText: (value: string) => Promise<void> = (value) => navigator.clipboard.writeText(value),
  schedule: (callback: () => void, delay: number) => unknown = setTimeout,
): Promise<void> {
  const originalText = button.textContent || "Copy source";
  button.disabled = true;
  try {
    await writeText(source);
    button.textContent = "✓ Copied!";
    button.setAttribute("aria-label", "Source copied");
  } catch {
    button.textContent = "Copy failed — try again";
    button.setAttribute("aria-label", "Copy failed. Try again");
  } finally {
    button.disabled = false;
    schedule(() => {
      button.textContent = originalText;
      button.setAttribute("aria-label", originalText);
    }, 2_000);
  }
}
